export default [
  {
    title: 'Go To REST API',
    imageUrl: '/images/projects/reat_api_v1.jpg',
    href: '/restapiv1'
  },
  {
    title: 'Go To REST API + Front',
    imageUrl: '/images/projects/springboot.png',
    href: '/springboot'
  },
  {
    title: 'Go To snmp-fiberhome',
    imageUrl: '/images/projects/npm_capa.png',
    href: '/snmpfiberhome'
  },
  {
    title: 'Go To swagger-autogen',
    imageUrl: '/images/projects/npm_capa2.png',
    href: '/swaggerautogen'
  }
];